import { InjectionToken } from '@angular/core';

import { OverviewPageAPI } from '@recruitee/dashboard-types';

export const OVERVIEW_PAGE_API = new InjectionToken<OverviewPageAPI>('OverviewPageAPI');
